import { render, staticRenderFns } from "./procurementBlick.vue?vue&type=template&id=f46e2d86&scoped=true"
import script from "./procurementBlick.vue?vue&type=script&lang=js"
export * from "./procurementBlick.vue?vue&type=script&lang=js"
import style0 from "./procurementBlick.vue?vue&type=style&index=0&id=f46e2d86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46e2d86",
  null
  
)

export default component.exports